import * as React from "react";
import { TextInput, BooleanInput, ReferenceInput, SelectInput } from "react-admin";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { SourceCustomer } from "../../Customer";
import { SourceRemoveReasonTypes } from "../../RemovalReasonType";

const RemoveReasonDetailCreateForm = () => {
  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Information
                </Typography>
                <BooleanInput label="Is Required" source="isRequired" />
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <ReferenceInput
                    label="CUSTOMER"
                    source="customerId"
                    reference={SourceCustomer}
                    required
                    filters={{ isActive__eq: true }}
                    fullWidth
                  >
                    <SelectInput optionText="customerName" optionValue="id" />
                  </ReferenceInput>
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <ReferenceInput
                    label="REMOVE REASON TYPE"
                    source="removeReasonTypeId"
                    reference={SourceRemoveReasonTypes}
                    filters={{ isActive__eq: true }}
                    fullWidth
                  >
                    <SelectInput optionText="removeReasonTypeName" optionValue="id" />
                  </ReferenceInput>
                </Box>
              </Box>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="removeReasonDetailCode" label="REMOVE REASON DETAIL CODE" required fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="removeReasonDetailName" label="REMOVE REASON DETAIL NAME" required fullWidth />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default RemoveReasonDetailCreateForm;
